import React, { CSSProperties } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

export type DividerType = 'horizontal' | 'vertical';

interface DividerProps {
    type?: DividerType;
    color?: string;
    style?: CSSProperties;
    className?: string;
}

const Divider: React.FC<React.PropsWithChildren<DividerProps>> = ({
    type = 'horizontal',
    color = aampeTheme.colors.bordersWG01,
    style = {},
    className,
}: DividerProps) => (
    <DividerContainer
        className={className}
        type={type}
        color={color}
        style={style}
    />
);

const DividerContainer: any = styled.div((props: any) => {
    if (props.type === 'horizontal') {
        return { borderBottom: `1px solid ${props.color}`, ...props.style };
    }
    return { borderLeft: `1px solid ${props.color}`, ...props.style };
});

export default Divider;
